import { LoginFormContainer } from './loginFormContainer';

export default LoginFormContainer;
